// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","zGreen":"#BFD730","widget":"Qg2t","title":"_1PIj","price":"_2dJw","port":"_2Egb","inputs":"JFr9","outputs":"_1huD","body":"Shpy"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Flows/Flow/CustomNode/CustomNodeWidget/CustomNodeWidget.scss
// module id = S98g
// module chunks = 0